// Created by hejikun on 2017/11/2 0002.
let train = [
  {
    path: '/train',
    name: '健康直通车',
    component: () => import('@/pages/train/index')
  }
  // {
  //   path: '/train_choose',
  //   name: '健康直通车',
  //   component: () => import('@/pages/train/train_choose'),
  //   children: [
  //     {
  //       path: '',
  //       name: '健康直通车',
  //       component: () => import('@/pages/train/type1_appointment')
  //     },
  //     {
  //       path: '/train_choose/type1',
  //       name: '健康直通车 - 门诊预约',
  //       component: () => import('@/pages/train/type1_appointment')
  //     },
  //     {
  //       path: '/train_choose/type2',
  //       name: '健康直通车 - 住院预约',
  //       component: () => import('@/pages/train/type2_hospital')
  //     },
  //     {
  //       path: '/train_choose/type3',
  //       name: '健康直通车 - 检查预约',
  //       component: () => import('@/pages/train/type3_check')
  //     },
  //     {
  //       path: '/train_choose/type4',
  //       name: '健康直通车 - 体检预约',
  //       component: () => import('@/pages/train/type4_examination')
  //     }
  //   ]
  // },
  // {
  //   path: '/train_choose_path',
  //   name: '选择车程',
  //   component: () => import('@/pages/train/train_choose_path'),
  //   children: [
  //     {
  //       path: '/train_choose_path/type1',
  //       name: '选择车程 - 班车',
  //       component: () => import('@/pages/train/choose_path/type1')
  //     },
  //     {
  //       path: '/train_choose_path/type2',
  //       name: '选择车程 - 拼车',
  //       component: () => import('@/pages/train/choose_path/type2')
  //     },
  //     {
  //       path: '/train_choose_path/type3',
  //       name: '选择车程 - 专车',
  //       component: () => import('@/pages/train/choose_path/type3')
  //     }
  //   ]
  // },
  // {
  //   path: '/train_choose_hospital',
  //   name: '选择医院',
  //   component: () => import('@/pages/train/train_choose_hospital')
  // },
  // {
  //   path: '/train_choose_department',
  //   name: '选择科室',
  //   component: () => import('@/pages/train/train_choose_department'),
  //   children: [
  //     {
  //       path: '/train_choose_department/type1',
  //       name: '选择科室',
  //       component: () => import('@/pages/train/type1_appointment/department')
  //     },
  //     {
  //       path: '/train_choose_department/type2',
  //       name: '选择科室',
  //       component: () => import('@/pages/train/type2_hospital/department')
  //     }
  //   ]
  // },
  // {
  //   path: '/train_choose_doctor',
  //   name: '选择医生',
  //   component: () => import('@/pages/train/type1_appointment/doctor')
  // },
  // {
  //   path: '/train_choose_examination_items',
  //   name: '体检项目列表',
  //   component: () => import('@/pages/train/type4_examination/items')
  // },
  // {
  //   path: '/train_choose_check_items',
  //   name: '检查项目列表',
  //   component: () => import('@/pages/train/type3_check/items')
  // },
  // {
  //   path: '/train_doctor_index',
  //   name: '医生主页',
  //   component: () => import('@/pages/train/type1_appointment/doctor_index')
  // },
  // {
  //   path: '/train_prepare_cash',
  //   name: '预交金支付',
  //   component: () => import('@/pages/train/train_prepare_cash')
  // },
  // {
  //   path: '/train_wait',
  //   name: '车程确认',
  //   component: () => import('@/pages/train/train_wait')
  // },
  // {
  //   path: '/train_wait_bed',
  //   name: '床位确认',
  //   component: () => import('@/pages/train/train_wait_bed')
  // },
  // {
  //   path: '/train_map',
  //   name: '获取位置',
  //   component: () => import('@/pages/train/train_map')
  // },
  // {
  //   path: '/train_line_type2',
  //   name: '拼车 - 选择路线',
  //   component: () => import('@/pages/train/choose_path/type2_lines')
  // },
  // {
  //   path: '/train_line_type3',
  //   name: '专车 - 选择路线',
  //   component: () => import('@/pages/train/choose_path/type3_lines')
  // },
  // {
  //   path: '/train_order_list',
  //   name: '订单列表',
  //   component: () => import('@/pages/train/train_order_list')
  // },
  // {
  //   path: '/train_order_detail',
  //   name: '订单详情',
  //   component: () => import('@/pages/train/train_order_detail')
  // },
  // {
  //   path: '/train_pay',
  //   name: '订单支付',
  //   component: () => import('@/pages/train/train_pay')
  // },
  // {
  //   path: '/train_order',
  //   name: '订单确认',
  //   component: () => import('@/pages/train/train_order'),
  //   children: [
  //     {
  //       path: '',
  //       name: '订单确认',
  //       component: () => import('@/pages/train/type1_appointment/order')
  //     },
  //     {
  //       path: '/train_order/type1',
  //       name: '订单确认',
  //       component: () => import('@/pages/train/type1_appointment/order')
  //     },
  //     {
  //       path: '/train_order/type2',
  //       name: '订单确认',
  //       component: () => import('@/pages/train/type2_hospital/order')
  //     },
  //     {
  //       path: '/train_order/type3',
  //       name: '订单确认',
  //       component: () => import('@/pages/train/type3_check/order')
  //     },
  //     {
  //       path: '/train_order/type4',
  //       name: '订单确认',
  //       component: () => import('@/pages/train/type4_examination/order')
  //     }
  //   ]
  // }
]

export default train
